export default "__VITE_ASSET__dajwaptd__"